import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';

let AccountStatusDisplay = ({ ...props }) => {

    let accountId = props.accountId;

    let account = props.store.accounts.getById(accountId);

    let accountStatusChanges = [... account.accountStatusChanges];


    //console.log(account)
    //let statusChanges = account.accountStatusChanges;
    //console.log(statusChanges)

    let keyCount = 0;

    function getKey() {
        return keyCount++;
    }


    function getBootstrapClass(status) {
        if (status == "Locked") {
            return "danger"
        }
        else if (status == "pending") {
            return "warning"
        }
        return "success"
    }

    function currentAccountStatus(accountStatus) {

        let bootstrapClass = getBootstrapClass(accountStatus.status)
        return (
            <div key={getKey()} className={"p-3 m-3 alert-" + bootstrapClass}>
                <h2 className="h4">Current Account Status:</h2>
                <p className="h2">{accountStatus.status}</p>
                <p>{accountStatus.note}</p>
                <small><b>{moment(accountStatus.createdDate).format("MMMM Do YYYY, h:mm:ss a")}</b></small>
            </div>
        )
    }

    function getKey() {
        return "accountStatus-random-" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
    }

    if (accountStatusChanges && accountStatusChanges.length > 0) {
        const key = "accountStatus-random-" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
        let currAccountStatus = accountStatusChanges.pop();

        return (
            <div  >
                {currentAccountStatus(currAccountStatus)}

                {accountStatusChanges.length > 0 && (<h2>Previous Account Changes</h2>)}

                {accountStatusChanges.reverse().map((statusChange, index) =>
                    <div key={getKey()} className="mb-3">
                        <h3>{moment(statusChange.createdDate).format("DD/MM/YY")} - {statusChange.status}</h3>
                        <p>{statusChange.note}</p>
                        <small>{moment(statusChange.createdDate).format("MMMM Do YYYY, h:mm:ss a")}</small>
                    </div>
                )}
            </div>
        )
    }
    else {
        return (
            <div>
                <p>No status changes found for this account. (This means it's never been locked.)</p>
            </div>
        )
    }
}

AccountStatusDisplay = observer(AccountStatusDisplay)

export default AccountStatusDisplay;

